import { render } from "./KidsProductCatalog.vue?vue&type=template&id=72671bb2&scoped=true"
import script from "./KidsProductCatalog.vue?vue&type=script&lang=js"
export * from "./KidsProductCatalog.vue?vue&type=script&lang=js"

import "./KidsProductCatalog.vue?vue&type=style&index=0&id=72671bb2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72671bb2"]])

export default __exports__